'use client';

import { CarouselControl } from '@/components/Shares/CarouselControl';
import type { ContentsType } from '@/types';
import { Carousel } from '@mantine/carousel';
import { Box, Card, Group, Image, type MantineSpacing, Stack, type StyleProp } from '@mantine/core';
import { type PropsWithChildren, useState } from 'react';
export type CarouselLayoutProps = PropsWithChildren & ContentsType & {
  slideSize: StyleProp<number | string>;
  my?: StyleProp<MantineSpacing>;
  p?: StyleProp<MantineSpacing>;
  isShadow?: boolean;
};
export const CarouselLayout: React.FC<CarouselLayoutProps> = ({
  id,
  title,
  items,
  children,
  slideSize,
  my,
  p,
  isShadow
}) => {
  const [active, setActive] = useState(0);
  const handleNext = () => {
    setActive(prev => (prev + 1) % items.length);
  };
  const handlePrev = () => {
    setActive(prev => (prev - 1 + items.length) % items.length);
  };
  return <Card w="100%" bg="var(--navbar-bg-color)" id={`layout-${id}`} my={my} radius="sm" p={p}>
      <Stack>
        <Group justify="space-between" wrap="nowrap" gap={4}>
          <Box>{title}</Box>
          <CarouselControl link="#" handleNext={handleNext} handlePrev={handlePrev} />
        </Group>

        <Box pos="relative">
          <Image src="/assets/carousel-shadow.png" w={{
          base: '20%',
          lg: '10%'
        }} h="100%" pos="absolute" right={0} top={0} style={{
          zIndex: isShadow ? 1 : -1
        }} />
          <Carousel align="start" h="100%" slideSize={slideSize} slideGap="md" loop withControls={false} initialSlide={active} onSlideChange={setActive} containScroll="trimSnaps">
            {children}
          </Carousel>
        </Box>
      </Stack>
    </Card>;
};